<app-page-shell variant="default" [embedded]="campId != null">
<div class="card card-box mb-5">
      <div class="card-header py-3">
        <div class="card-header--title font-size-lg">
           {{ getInfluencerTypeForSelect(selectedInfluencer()) || 'Influencers'}}
        </div>
        <div class="card-header--actions">
            <a
              class="btn btn-sm btn-primary pull-right"
              [routerLink]="['/projects', id, 'influencers', 'add']"
              [queryParams]="getAddInfluencerQueryParams()"
              sbEntityLink
              role="button"
            >
              <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
              <span class="btn-wrapper--label">Add Influencer</span>
            </a>
          <a  class="pull-right" title="Import">
            <img class="ms-3 me-3 cursor-pointer " (click)="importInfluencers()"
                 src="../../assets/images/export-normal.png">
          </a>
          <a  class="pull-right" title="export">
            <img class="cursor-pointer ms-3 me-2" mat-icon-button [matMenuTriggerFor]="exportMenu"
                 src="../../assets/images/import-normal.png">
          </a>
          <mat-menu #exportMenu="matMenu" class="campaign-popover">
            <a class="dropdown-item" (click)="exportInfluencers('csv')">
              <i class="fa fa-file-o me-2"></i>CSV</a>
            <a class="dropdown-item" (click)="exportInfluencers('xlsx')">
              <i class="fa fa-file-excel-o me-2"></i>Excel (xlsx)</a>
          </mat-menu>
        </div>
      </div>
      <div class="d-flex flex-wrap align-items-center px-4 py-3">
        @if (!campId) {
        <div  class="client-dropdown">
          <app-creatable-select
            [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false" [selectedValue]="selectedInfluencer()"
            [placeholder]="'Select influencer type'" [selectOptions]="influencerTypes"
            (optionSelected)="filterInfluencers($event)"></app-creatable-select>
        </div>
        }
        @if (!campId) {
        <div  class="client-dropdown" >
          <app-creatable-select #influencerSegment  [selectedValue]="selectedSegment()" [hideLabel]="true"
                                [isCreatable]="false" [onlyBottomBorder]="false" [placeholder]="'Select Segment'" [customTemplate]="manageSegmentMain"
                                [selectOptions]="filteredSegments" (optionSelected)="filterSegments($event)">
          </app-creatable-select>
        </div>
        }

        <div class="client-dropdown">
          <app-creatable-select
            [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false" [selectedValue]="selectedPromoCode"
            [placeholder]="'Filter by Promo Code'" [selectOptions]="promoCodeType"
            (optionSelected)="filterPromoCode($event)" valueKey="value"></app-creatable-select>
        </div>

        <div class="client-dropdown">
          <app-creatable-select
            [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false" [selectedValue]="selectedBadgeImageUrl"
            [placeholder]="'Filter by Badge Image Url'" [selectOptions]="badgeImageUrlType"
            (optionSelected)="filterBadgeImageUrl($event)" valueKey="value"></app-creatable-select>
        </div>

        @if (campId) {
        <div class='customize-email d-flex align-items-center'>
          <div class="me-2">
            <input id="include_added_influencers" placeholder="" [checked]="includeAddedInfluencers"
                   (change)="includeAddedInfluencersChanged($event)" type="checkbox">
            <label for="include_added_influencers">Always display already added influencers</label>
            <app-info-popover
              info="Display influencers that are already part of the campaign regardless of the selected segment">
            </app-info-popover>
          </div>
        </div>
        }

        @if (campId) {
        <div class="row col-12 mt-4 mb-4">
          <div class="row col-12 align-items-start mt-1">
            @if (selectedInfluencerSegmentPairs().length > 0) {
            <div class="client-dropdown">
              <app-creatable-select
                [hideLabel]="true"
                [isCreatable]="false"
                [onlyBottomBorder]="false"
                [selectedValue]="selectedInfluencerSegmentPairs()[0].influencerType"
                [placeholder]="'Select influencer type'"
                [selectOptions]="filteredInfluencerTypes"
                (optionSelected)="onInfluencerTypeSelected(0, $event)">
              </app-creatable-select>
            </div>
            }

            <div cdkDropList (cdkDropListDropped)="dropSegmentPair($event)" class="cd-segment-drop-list">
              @for (pair of selectedInfluencerSegmentPairs(); track pair; let i = $index) {
              <div
                   class="d-flex align-items-center mt-1"
                   [cdkDrag]="i !== selectedInfluencerSegmentPairs().length - 1"
                   [cdkDragDisabled]="i === selectedInfluencerSegmentPairs().length - 1">

                @if (i !== selectedInfluencerSegmentPairs().length - 1) {
                <div class="cd-drag-handle d-flex align-items-center" cdkDragHandle
                    >
                  <i class="fa fa-bars"></i>
                </div>
                }
                @if (i === selectedInfluencerSegmentPairs().length - 1) {
                <div class="cd-drag-handle-spacer"></div>
                }

                <div class="client-dropdown" style="margin-right: 0px">
                  <app-creatable-select
                    [selectedValue]="pair.segment"
                    [hideLabel]="true"
                    [isCreatable]="false"
                    [onlyBottomBorder]="false"
                    [placeholder]="'Select Segment'"
                    [customTemplate]="manageSegmentTemplate"
                    [selectOptions]="pair.filteredSegments"
                    (optionSelected)="onSegmentSelected(i, $event)">
                    <ng-template #manageSegmentTemplate>
                      <button (click)="manageSegments($safeNavigationMigration(pair.influencerType?.id), i)" class="btn btn-sm w-100" type="button" role="button">
                        <span class="btn-wrapper--label">Manage Segments</span>
                      </button>
                    </ng-template>
                  </app-creatable-select>
                </div>

                @if (i !== selectedInfluencerSegmentPairs().length - 1) {
                <button
                  class="btn btn-sm rounded-circle ms-2 text-white my-0 me-0 p-0 d-flex align-items-center justify-content-center remove-button"
                  type="button"
                  (click)="removePair(i)"
                >
                  <span class="btn-wrapper--icon"><i class="fa fa-minus"></i></span>
                </button>
                }
              </div>
              }
            </div>
          </div>

          @if (unaddedInfluencerSegmentPairs && unaddedInfluencerSegmentPairs.length > 0 && !!unaddedInfluencerSegmentPairs[0].influencerType) {
          <div class="col-12 mt-4">
            <div class="row">
              <p>There are influencers on this campaign from these category and segment as well</p>
            </div>
            @for (pair of unaddedInfluencerSegmentPairs; track pair; let i = $index) {
            <div class="row align-items-center mt-1">
              <div class="client-dropdown">
                <app-creatable-select
                  [class.d-none]="true"
                  [hideLabel]="true"
                  [isCreatable]="false"
                  [onlyBottomBorder]="false"
                  [selectedValue]="pair.influencerType"
                  [placeholder]="'Select influencer type'"
                  [selectOptions]="influencerTypes"
                  [isDisabled]="true"
                  (optionSelected)="onInfluencerTypeSelected(i, $event)">
                </app-creatable-select>
              </div>

              <div class="client-dropdown" style="margin-right: 0px">
                <app-creatable-select
                  [selectedValue]="pair.segment"
                  [hideLabel]="true"
                  [isCreatable]="false"
                  [onlyBottomBorder]="false"
                  [placeholder]="'Select Segment'"
                  [customTemplate]="manageUnaddedSegmentTemplate"
                  [selectOptions]="pair.filteredSegments"
                  [isDisabled]="true"
                  (optionSelected)="onSegmentSelected(i, $event)">
                  <ng-template #manageUnaddedSegmentTemplate>
                    <button (click)="manageSegments($safeNavigationMigration(pair.influencerType?.id))" class="btn btn-sm w-100" type="button" role="button">
                      <span class="btn-wrapper--label">Manage Segments</span>
                    </button>
                  </ng-template>
                </app-creatable-select>
              </div>

              <button
                class="btn btn-sm rounded-circle ms-2 text-white my-0 me-0 p-0 d-flex align-items-center justify-content-center add-button"
                type="button"
                (click)="addUnaddedPair(pair)"
              >
                <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
              </button>
            </div>
            }
          </div>
          }
        </div>
        }

        @if (referredByInfluencer?.id) {
        <div class="referred-msg">
          <span>Showing referrals for <b>{{referredByInfluencer.name}}</b> ({{referredByInfluencer.id}})</span>
          <i class="clear-referral fa fa-times ms-2" (click)="clearReferredByInfluencer($event)" aria-hidden="true"></i>
        </div>
        }
        <ng-template #manageSegmentMain>
          <button (click)="manageSegments(selectedInfluencer())" class="btn btn-sm w-100" type="button" role="button">
            <span class="btn-wrapper--label">Manage Segments</span>
          </button>
        </ng-template>
      </div>

      <div class="p-3">
        <!-- The campaign audience waits for its campaign before the table asks for its first page. -->
        @if (tableReady()) {
        <app-sb-table #influencersTable
          [class.influencers-show-all]="showAll"
          [rows]="influencersLocal()"
          [totalRows]="totalRows()"
          [columns]="tableColumns"
          [options]="tableOptions"
          displayAllColumnsLabel="Display all columns"
          [displayAllColumns]="showAll"
          (displayAllColumnsChange)="showAllColumns($event)"
          (stateChange)="onTableState($event)">

          <!-- Bulk actions: the design system's bulk bar, with this list's own buttons and menus, on top of the table. -->
          @if (selectAllInfluencer || includedIdList.length > 0) {
          <app-sb-bulk-bar sbTableBulk [attached]="true"
                           ariaLabel="Actions for the selected influencers" itemsLabel="influencers"
                           [count]="bulkCount" [allMatching]="selectAllInfluencer" [matchingCount]="influencerCount"
                           [canSelectAllMatching]="masterSelected && influencerCount > influencersLocal().length"
                           [progress]="bulkRunning ? bulkProgressLabel() : null"
                           (selectAllMatching)="checkAllInfluencer()" (clearSelection)="uncheckAllInfluencer()">
            @if (selectedSegment() && selectedInfluencer()) {
            <button type="button" class="btn btn-sm sb-bulk-bar__btn"
                    (click)="openMoveToSegment()">
              <i class="fa fa-exchange me-1" aria-hidden="true"></i>Move to segment
            </button>
            }
            @if (selectedInfluencer()) {
              <button type="button" class="btn btn-sm sb-bulk-bar__btn" [matMenuTriggerFor]="exclusionMenu">
                <i class="fa fa-ban me-1" aria-hidden="true"></i>Campaign exclusion<i class="fa fa-caret-down ms-1" aria-hidden="true"></i>
              </button>
              <mat-menu #exclusionMenu="matMenu">
                @for (option of skipActions; track option) {
                <button type="button" mat-menu-item (click)="confirmSkip(option)">
                  <i class="fa me-2" [class]="option.icon" aria-hidden="true"></i>{{option.name}}
                </button>
                }
              </mat-menu>
            }
            <button type="button" class="btn btn-sm sb-bulk-bar__btn" [matMenuTriggerFor]="unsubscribeMenu">
              <i class="fa fa-envelope-o me-1" aria-hidden="true"></i>Unsubscribe<i class="fa fa-caret-down ms-1" aria-hidden="true"></i>
            </button>
            <mat-menu #unsubscribeMenu="matMenu">
              <button type="button" mat-menu-item (click)="unsubscribeSelectedInfluencer('opt_out')">
                <i class="fa fa-bell-slash-o me-2" aria-hidden="true"></i>Opt out of marketing emails
              </button>
              <button type="button" mat-menu-item (click)="unsubscribeSelectedInfluencer('anonymize')">
                <i class="fa fa-user-secret me-2" aria-hidden="true"></i>Remove personal data (anonymize)
              </button>
            </mat-menu>
            <button type="button" class="btn btn-sm sb-bulk-bar__btn sb-bulk-bar__btn--danger" (click)="deleteSelectedInfluencer()">
              <i class="fa fa-trash me-1" aria-hidden="true"></i>Delete
            </button>
          </app-sb-bulk-bar>
          }

          <ng-template sbTableHeader="select">
            @if (influencersLocal()?.length) {
            <app-sb-input-checkbox layout="inline" [id]="'influencers-select-page'" label="" ariaLabel="Select the influencers on this page"
                                   [ngModel]="masterSelected"
                                   (ngModelChange)="masterSelected = $event; checkUncheckAllInfluencer()"></app-sb-input-checkbox>
            }
          </ng-template>

          <ng-template sbTableHeader="applied_action">
            Applied Action
            <div class="column-filter-dropdown" ngbDropdown #appliedActionDropdown="ngbDropdown" container="body">
              <button class="column-filter-btn" type="button" ngbDropdownToggle
                      [class.active-filter]="selectedAppliedAction().length > 0"
                      (click)="$event.stopPropagation()">
                <i class="fa fa-filter"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu column-filter-menu">
                @for (action of appliedActionType; track action) {
                <div class="dropdown-item" (click)="$event.stopPropagation()">
                  <label class="mb-0 cursor-pointer d-flex align-items-center">
                    <input
                      type="checkbox"
                      [checked]="action.checked"
                      (change)="filterAppliedAction(action.value)"
                      class="me-2"
                    />
                    <span>{{action.name}}</span>
                  </label>
                </div>
                }
              </div>
            </div>
          </ng-template>

          <ng-template sbTableHeader="email_delivery">
            Email Delivery
            <div class="column-filter-dropdown" ngbDropdown #emailFailedReasonDropdown="ngbDropdown" container="body">
              <button class="column-filter-btn" type="button" ngbDropdownToggle
                      [class.active-filter]="selectedEmailFailedReason().length > 0"
                      (click)="$event.stopPropagation()">
                <i class="fa fa-filter"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu column-filter-menu">
                @for (efr of emailFailedReasonType; track efr) {
                <div class="dropdown-item" (click)="$event.stopPropagation()">
                  <label class="mb-0 cursor-pointer d-flex align-items-center">
                    <input
                      type="checkbox"
                      [checked]="efr.checked"
                      (change)="filterEmailFailedReason(efr.value)"
                      class="me-2"
                    />
                    <span>{{efr.name}}</span>
                  </label>
                </div>
                }
              </div>
            </div>
          </ng-template>

          <ng-template sbTableHeader="preferences">
            Preferences
            <div class="column-filter-dropdown" ngbDropdown #dataRemovedDropdown="ngbDropdown" container="body">
              <button class="column-filter-btn" type="button" ngbDropdownToggle
                      [class.active-filter]="selectedDataRemoved()"
                      (click)="$event.stopPropagation()">
                <i class="fa fa-filter"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu column-filter-menu">
                @for (opt of dataRemovedType; track opt) {
                <div class="dropdown-item" (click)="$event.stopPropagation()">
                  <label class="mb-0 cursor-pointer d-flex align-items-center">
                    <input
                      type="checkbox"
                      [checked]="opt.checked"
                      (change)="filterDataRemovedFromColumn(opt.value)"
                      class="me-2"
                    />
                    <span>{{opt.name}}</span>
                  </label>
                </div>
                }
              </div>
            </div>
          </ng-template>

          <ng-template sbTableHeader="source">
            Source
            <div class="column-filter-dropdown" ngbDropdown #sourceDropdown="ngbDropdown" container="body">
              <button class="column-filter-btn" type="button" ngbDropdownToggle
                      [class.active-filter]="selectedSourceType().length > 0"
                      (click)="$event.stopPropagation()">
                <i class="fa fa-filter"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu source-filter-dropdown">
                @for (source of sourceTypes; track source) {
                <div class="dropdown-item" (click)="$event.stopPropagation()">
                  <label class="mb-0 cursor-pointer d-flex align-items-center">
                    <input
                      type="checkbox"
                      [checked]="source.checked"
                      (change)="filterInfluencerSourceType(source.value)"
                      class="me-2"
                    />
                    <span>{{source.name}}</span>
                  </label>
                </div>
                }
              </div>
            </div>
          </ng-template>

          <ng-template sbTableHeader="email_validity">
            Email Validity
            <div class="column-filter-dropdown" ngbDropdown #emailValidationDropdown="ngbDropdown" container="body">
              <button class="column-filter-btn" type="button" ngbDropdownToggle
                      [class.active-filter]="selectedEmailValidationStatus().length > 0"
                      (click)="$event.stopPropagation()">
                <i class="fa fa-filter"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu column-filter-menu">
                @for (evs of emailValidationStatusType; track evs) {
                <div class="dropdown-item" (click)="$event.stopPropagation()">
                  <label class="mb-0 cursor-pointer d-flex align-items-center">
                    <input
                      type="checkbox"
                      [checked]="evs.checked"
                      (change)="filterEmailValidationStatus(evs.value)"
                      class="me-2"
                    />
                    <span>{{evs.name}}</span>
                  </label>
                </div>
                }
              </div>
            </div>
          </ng-template>

          <ng-template sbTableHeader="skip">
            Skip
            <div class="column-filter-dropdown" ngbDropdown #skipDropdown="ngbDropdown" container="body">
              <button class="column-filter-btn" type="button" ngbDropdownToggle
                      [class.active-filter]="selectedSkipped().length > 0"
                      (click)="$event.stopPropagation()">
                <i class="fa fa-filter"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu column-filter-menu">
                @for (skip of skippedType; track skip) {
                <div class="dropdown-item" (click)="$event.stopPropagation()">
                  <label class="mb-0 cursor-pointer d-flex align-items-center">
                    <input
                      type="checkbox"
                      [checked]="skip.checked"
                      (change)="filterSkipped(skip.value)"
                      class="me-2"
                    />
                    <span>{{skip.name}}</span>
                  </label>
                </div>
                }
              </div>
            </div>
          </ng-template>

          @for (field of customFields; track field; let i = $index) {
          <ng-template [sbTableHeader]="field">
            Custom {{i + 1}}
            <div class="column-filter-dropdown" ngbDropdown container="body" autoClose="outside">
              <button class="column-filter-btn" type="button" ngbDropdownToggle
                      [class.active-filter]="customFieldFilterActive(field)"
                      [attr.aria-label]="'Filter Custom ' + (i + 1)"
                      (click)="$event.stopPropagation()">
                <i class="fa fa-filter"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu column-filter-menu custom-field-filter-menu" (click)="$event.stopPropagation()">
                <!-- No ids or radio names: the table keeps a hidden copy of its header, so they would clash. -->
                <form class="px-3 pt-1 pb-2" (ngSubmit)="applyCustomFieldText(field)">
                  <label class="d-block mb-0">
                    <span class="d-block small mb-1">Contains</span>
                    <span class="d-flex align-items-center gap-2">
                      <input type="text" class="form-control form-control-sm" name="contains"
                             [(ngModel)]="customFieldDrafts[field]" [disabled]="!!customFieldPresence(field)" placeholder="Text">
                      <button type="submit" class="btn btn-sm btn-primary" [disabled]="!!customFieldPresence(field)">Apply</button>
                    </span>
                  </label>
                </form>
                @for (presence of customFieldPresenceTypes; track presence.value) {
                <div class="dropdown-item">
                  <label class="mb-0 cursor-pointer d-flex align-items-center">
                    <input
                      type="radio"
                      [checked]="customFieldPresence(field) === presence.value"
                      (change)="filterCustomFieldPresence(field, presence.value)"
                      class="me-2"
                    />
                    <span>{{presence.name}}</span>
                  </label>
                </div>
                }
                @if (customFieldFilterActive(field)) {
                <div class="px-3 pt-1">
                  <button type="button" class="btn btn-link btn-sm p-0" (click)="clearCustomFieldFilter(field)">Clear filter</button>
                </div>
                }
              </div>
            </div>
          </ng-template>
          }

          <ng-template sbTableHeader="referral_time_to_register">
            Time to register
            <div class="column-filter-dropdown" ngbDropdown container="body" autoClose="outside" placement="bottom-end bottom-start" #timeToRegisterDropdown="ngbDropdown">
              <button class="column-filter-btn" type="button" ngbDropdownToggle
                      [class.active-filter]="timeToRegisterLt() !== null"
                      [attr.aria-label]="'Filter Time to register: ' + timeToRegisterLabel(timeToRegisterLt())"
                      (click)="$event.stopPropagation()">
                <i class="fa fa-filter"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu column-filter-menu time-to-register-menu" (click)="$event.stopPropagation()">
                <app-time-to-register-filter [value]="timeToRegisterLt()"
                  (valueChange)="filterTimeToRegister($event); timeToRegisterDropdown.close()"></app-time-to-register-filter>
              </div>
            </div>
          </ng-template>

          <ng-template sbTableCell="select" let-influencer>
            <app-sb-input-checkbox layout="inline" [id]="'influencers-select-' + influencer.id" label=""
                                   [ariaLabel]="'Select influencer ' + influencer.id"
                                   [ngModel]="!!influencer.selected"
                                   (ngModelChange)="influencer.selected = $event; onChangeInfluencerSelection($event, influencer.id)"></app-sb-input-checkbox>
          </ng-template>

          <ng-template sbTableCell="tracking_source_flag" let-influencer>
            @if (currentUser?.can('index.all', 'influencer') && checkReferredThroughTrackerSource($safeNavigationMigration(influencer?.referred_through_tracker_source))?.message?.length) {
              <button type="button" class="info-button" [ngbPopover]="popTemplate"
                      triggers="mouseenter:mouseleave" placement="auto" [container]="'body'"
                      [popoverClass]="'info-popover'">
                <i class="fa fa-asterisk"></i>
              </button>
              <ng-template #popTemplate>{{currentUser?.can('index.all', 'influencer') && checkReferredThroughTrackerSource($safeNavigationMigration(influencer?.referred_through_tracker_source))?.message}}</ng-template>
            }
            <!-- The row of a conversion tracked inaccurately is red: the stylesheet colours the row that holds this. -->
            @if (currentUser?.can('index.all', 'influencer') && checkReferredThroughTrackerSource($safeNavigationMigration(influencer?.referred_through_tracker_source))?.isRedBackground) {
            <span class="influencer-row-flag"></span>
            }
          </ng-template>

          <ng-template sbTableCell="id" let-influencer>{{influencer.id}}</ng-template>

          <ng-template sbTableCell="name" let-influencer>
            @if (influencer.is_generic && influencer.email_alias) {
            <span [ngbPopover]="influencer.email" triggers="mouseenter:mouseleave" placement="top" container="body">{{influencer.prefix}} {{influencer.email_alias + " (" + getInfluencerType(influencer.influencer_type_id) + ")"}}</span>
            }
            @if (influencer.is_generic && !influencer.email_alias) {
            <span>{{influencer.prefix}} {{influencer.email + " (" + getInfluencerType(influencer.influencer_type_id) + ")"}}</span>
            }
            @if (!influencer.is_generic) {
            <span>{{influencer.prefix}} {{influencer.name}}</span>
            }
          </ng-template>

          <ng-template sbTableCell="company" let-influencer>{{influencer.company}}</ng-template>

          <ng-template sbTableCell="impressions" let-influencer>{{influencer.pageViews}}</ng-template>

          <ng-template sbTableCell="referrals" let-influencer>
            <span [class.referred-count]="influencer.referred_count > 0"
                  (click)="influencer.referred_count > 0 && filterReferredByInfluencer(influencer)">{{influencer.referred_count}}</span>
              @if (influencer.referred_count > 0) {
              <span (click)="influencer.referred_count > 0 && showReferralList(influencer.id, (influencer.first_name + ' ' +influencer.last_name))">
              <i class="fa fa-external-link ms-1 cursor-pointer" aria-hidden="true"></i>
            </span>
}
          </ng-template>

          <ng-template sbTableCell="links" let-influencer>
            @if (campaign?.meta && influencer.campaign_influencer_page_url) {
            <a href="{{influencer?.campaign_influencer_page_url}}" target="_blank">Landing</a>
            }
            @if (campaign?.meta && influencer.campaign_influencer_page_url) {
            <span> | </span>
            }
            @if (campaign?.meta && campaign?.meta?.social_networks && influencer.campaign_influencer_share_page_url && (!influencer?.is_generic || (influencer?.is_generic && campaign?.meta?.public_widget_enabled))) {
            <a href="{{influencer?.campaign_influencer_share_page_url}}" target="_blank">Share</a>
            }
            @if (campaign?.meta && campaign?.meta?.social_networks && influencer.campaign_influencer_share_page_url && (!influencer?.is_generic || (influencer?.is_generic && campaign?.meta?.public_widget_enabled))) {
            <span> | </span>
            }
            <a href="{{influencer.public_info_update_page_url}}" target="_blank">Info Update</a>
          </ng-template>

          <ng-template sbTableCell="applied_action" let-influencer>{{this.campId ? influencer?.campaign_influencer[0]?.applied_action : ''}}</ng-template>

          <ng-template sbTableCell="email_delivery" let-influencer>
            @if (this.campId) {
              @if (influencer.emailStatus === 'opened' && !influencer.emailFailedReason) {
              <span class="email-status-badge email-status-delivered">
                <i class="fa fa-envelope-open me-1"></i>Opened
              </span>
              }
              @if (influencer.emailStatus === 'clicked' && !influencer.emailFailedReason) {
              <span class="email-status-badge email-status-delivered">
                <i class="fa fa-mouse-pointer me-1"></i>Clicked
              </span>
              }
              @if (influencer.emailStatus === 'delivered' && !influencer.emailFailedReason) {
              <span class="email-status-badge email-status-delivered-confirmed">
                <i class="fa fa-inbox me-1"></i>Delivered
              </span>
              }
              @if (influencer.emailStatus === 'sent' && !influencer.emailFailedReason) {
              <span class="email-status-badge email-status-sent">
                <i class="fa fa-check-circle me-1"></i>Sent
              </span>
              }
              @if (influencer.emailStatus === 'temporarily-failed') {
              <span class="email-status-badge email-status-temporarily-failed"
                    [ngbPopover]="tempFailedReasonPopover"
                    triggers="mouseenter:mouseleave"
                    placement="auto"
                    [container]="'body'"
                    [popoverClass]="'info-popover'">
                <i class="fa fa-exclamation-circle me-1"></i>Temporarily Failed
                <ng-template #tempFailedReasonPopover>
                  <div class="email-failed-popover">
                    <div class="email-failed-popover-reason"><i class="fa fa-exclamation-triangle me-1"></i>{{humanize(influencer.emailFailedReason)}}</div>
                    @if (influencer.emailFailedReasonInfo) {
                    <div class="email-failed-popover-details">{{influencer.emailFailedReasonInfo}}</div>
                    }
                  </div>
                </ng-template>
              </span>
              }
              @if (influencer.emailFailedReason && influencer.emailFailedReason !== 'invalid_email' && influencer.emailStatus !== 'temporarily-failed') {
              <span class="email-status-badge email-status-failed"
                    [ngbPopover]="failedReasonPopover"
                    triggers="mouseenter:mouseleave"
                    placement="auto"
                    [container]="'body'"
                    [popoverClass]="'info-popover'">
                <i class="fa fa-times-circle me-1"></i>Failed
                <ng-template #failedReasonPopover>
                  <div class="email-failed-popover">
                    <div class="email-failed-popover-reason"><i class="fa fa-exclamation-triangle me-1"></i>{{humanize(influencer.emailFailedReason)}}</div>
                    @if (influencer.emailFailedReasonInfo) {
                    <div class="email-failed-popover-details">{{influencer.emailFailedReasonInfo}}</div>
                    }
                  </div>
                </ng-template>
              </span>
              }
              @if (influencer.emailStatus === 'queue') {
              <span class="email-status-badge email-status-queued">
                <i class="fa fa-hourglass-half me-1"></i>Queued
              </span>
              }
              @if (!influencer.emailStatus) {
              <span class="email-status-badge email-status-none">-</span>
              }
            }
          </ng-template>

          <ng-template sbTableCell="preferences" let-influencer>
            @if (influencer?.data_removed) {
            <span class="badge text-bg-secondary me-1">Data removal</span>
            }
            @if (influencer?.preference_suppress_email && !influencer?.data_removed && !isEmailPauseFrequency(influencer.preference_email_frequency)) {
            <span
                  class="badge text-bg-warning me-1">Marketing email opt-out</span>
            }
            @if (influencer?.preference_email_frequency && influencer.preference_email_frequency !== 'standard') {
            <span
                  class="badge text-bg-info me-1">{{formatEmailFrequencyLabel(influencer.preference_email_frequency)}}</span>
            }
            @if (influencer?.preference_suppress_email_open_tracking && !influencer?.preference_suppress_all_tracking) {
            <span class="badge text-bg-light me-1">No email open track</span>
            }
            @if (influencer?.preference_suppress_all_tracking) {
            <span class="badge text-bg-light me-1">No tracking</span>
            }
            @if (influencer?.preference_reason) {
            <div class="text-muted small mt-1">Reason: {{influencer.preference_reason}}</div>
            }
          </ng-template>

          <ng-template sbTableCell="source" let-influencer>{{influencer.source || '-'}}</ng-template>

          <ng-template sbTableCell="registration_platform" let-influencer>{{influencer.registration_platform?.name || '-'}}</ng-template>

          <ng-template sbTableCell="updated_at" let-influencer>{{formatMoment(influencer.updated_at) | tzDate : false : 'DD-MM-YYYY hh:mm a'}}</ng-template>

          <ng-template sbTableCell="email_validity" let-influencer>
            @if (influencer.email_address_validation_status === 'valid') {
            <span class="email-status-badge email-status-delivered">
              <i class="fa fa-check-circle me-1"></i>Valid
            </span>
            }
            @if (influencer.email_address_validation_status === 'invalid') {
            <span class="email-status-badge email-status-failed"
                  [ngbPopover]="'This email address has been validated as invalid and will be skipped during campaign launches.'"
                  triggers="mouseenter:mouseleave"
                  placement="auto"
                  [container]="'body'"
                  [popoverClass]="'info-popover'">
              <i class="fa fa-times-circle me-1"></i>Invalid
            </span>
            }
            @if (!influencer.email_address_validation_status) {
            <span class="email-status-badge email-status-none">-</span>
            }
          </ng-template>

          <ng-template sbTableCell="skip" let-influencer>{{formatSkipValue($safeNavigationMigration(influencer?.skip))}}</ng-template>

          <ng-template sbTableCell="created_at" let-influencer>{{formatMoment(influencer.created_at) | tzDate : false : 'DD-MM-YYYY hh:mm a'}}</ng-template>

          <ng-template sbTableCell="email" let-influencer>
            @if (influencer.email_alias) {
            <span [ngbPopover]="influencer.email" triggers="mouseenter:mouseleave" placement="top" container="body">{{influencer.email_alias}}</span>
            }
            @if (!influencer.email_alias) {
            <span>{{influencer.email}}</span>
            }
          </ng-template>

          <ng-template sbTableCell="image" let-influencer>
            <img class="image-thumbnail" [src]="influencer.image" alt=""/>
          </ng-template>

          <ng-template sbTableCell="influencer_type_id" let-influencer>{{getInfluencerType(influencer.influencer_type_id)}}</ng-template>

          <ng-template sbTableCell="project_influencer_segment_id" let-influencer>{{getInfluencerSegment(influencer.project_influencer_segment_id)}}</ng-template>

          <ng-template sbTableCell="registration_url" let-influencer>{{influencer.registration_url}}</ng-template>

          <ng-template sbTableCell="prefix" let-influencer>{{influencer.prefix}}</ng-template>

          <ng-template sbTableCell="first_name" let-influencer>{{influencer.first_name}}</ng-template>

          <ng-template sbTableCell="last_name" let-influencer>{{influencer.last_name}}</ng-template>

          <ng-template sbTableCell="suffix" let-influencer>{{influencer.suffix}}</ng-template>

          <ng-template sbTableCell="phone" let-influencer>{{influencer.phone}}</ng-template>

          <ng-template sbTableCell="video_url" let-influencer>{{influencer.video_url}}</ng-template>

          <ng-template sbTableCell="booth_number" let-influencer>{{influencer.booth_number}}</ng-template>

          <ng-template sbTableCell="promo_code" let-influencer>{{influencer.promo_code}}</ng-template>

          <ng-template sbTableCell="badge_image_url" let-influencer>
            @if (influencer.badge_image_url) {
            <img [src]="influencer.badge_image_url" alt="Badge" style="max-height: 40px; max-width: 80px;">
            }
          </ng-template>

          <ng-template sbTableCell="platform_unique_id" let-influencer>{{influencer.platform_unique_id}}</ng-template>

          <ng-template sbTableCell="job_title" let-influencer>{{influencer.job_title}}</ng-template>

          <ng-template sbTableCell="sessions" let-influencer>{{getSessionTitle(influencer)}}</ng-template>

          <ng-template sbTableCell="custom_1" let-influencer>{{influencer.custom_1}}</ng-template>

          <ng-template sbTableCell="custom_2" let-influencer>{{influencer.custom_2}}</ng-template>

          <ng-template sbTableCell="custom_3" let-influencer>{{influencer.custom_3}}</ng-template>

          <ng-template sbTableCell="custom_4" let-influencer>{{influencer.custom_4}}</ng-template>

          <ng-template sbTableCell="custom_5" let-influencer>{{influencer.custom_5}}</ng-template>

          <ng-template sbTableCell="custom_6" let-influencer>{{influencer.custom_6}}</ng-template>

          <ng-template sbTableCell="custom_7" let-influencer>{{influencer.custom_7}}</ng-template>

          <ng-template sbTableCell="custom_8" let-influencer>{{influencer.custom_8}}</ng-template>

          <ng-template sbTableCell="custom_9" let-influencer>{{influencer.custom_9}}</ng-template>

          <ng-template sbTableCell="custom_10" let-influencer>{{influencer.custom_10}}</ng-template>

          <ng-template sbTableCell="referred_by" let-influencer>{{influencer.referred_by}}</ng-template>

          <ng-template sbTableCell="referred_by_campaign_id" let-influencer>{{influencer.referred_by_campaign_id}}</ng-template>

          <ng-template sbTableCell="referred_through_tracker_source" let-influencer>{{influencer.referred_through_tracker_source}}</ng-template>

          <ng-template sbTableCell="created_by" let-influencer>{{getCreateUpdateInfo(influencer.created_by)}}</ng-template>

          <ng-template sbTableCell="updated_by" let-influencer>{{getCreateUpdateInfo(influencer.updated_by)}}</ng-template>

          <ng-template sbTableCell="referral_time_to_register" let-influencer>{{timeToRegister(influencer)}}</ng-template>

          <ng-template sbTableActions let-influencer>
            <button class="btn-icon float-end" mat-icon-button [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu">
              <span class="fa fa-ellipsis-v"></span>
            </button>
            <mat-menu #menu="matMenu" class="campaign-popover">
              <a class="dropdown-item" [routerLink]="['/projects', id, 'influencers', 'view', influencer.id]" [queryParams]="{selectedInfluencerType: selectedInfluencer(), selectedSegment: selectedSegment(), campaignId: campId}" sbEntityLink>
                <i class="fa fa-pencil me-2"></i>Edit</a>
              @if (!(influencer.is_generic)) {
              <a class="dropdown-item" (click)="changeStatus(influencer)">
                <i class="fa fa-trash me-2"></i>Delete</a>
              }
              @if (!influencer.data_removed) {
              <a class="dropdown-item" href="{{influencer.influencer_preference_panel_url || influencer.preference_panel_url}}" target="_blank">
                <i class="fa fa-sliders me-2" aria-hidden="true"></i>Manage preferences</a>
              }
              @if (influencer.data_removed) {
              <a class="dropdown-item" href="{{influencer.influencer_preference_subscribe_panel_url || influencer.subscribe_panel_url}}" target="_blank">
                <i class="fa fa-check-circle me-2"></i>Subscribe</a>
              }
              @if (influencer?.id) {
              <a class="dropdown-item" (click)="openPreferenceHistory(influencer)">
                <i class="fa fa-history me-2"></i>Preference history</a>
              }
              @if (campaign?.email_from_name) {
              <a class="dropdown-item" (click)="sendTestEmails(influencer)" target="_blank">
                <i class="fa fa-paper-plane me-2" aria-hidden="true"></i>Send Email</a>
              }
            </mat-menu>
          </ng-template>
        </app-sb-table>
        }
      </div>
</div>
</app-page-shell>

<ng-template #moveToSegmentTpl>
  <app-sb-input-select
    label="Influencer type"
    [items]="influencerTypes"
    labelKey="name"
    valueKey="id"
    [clearable]="false"
    [ngModel]="moveTypeId"
    (ngModelChange)="onMoveTypeChange($event)">
  </app-sb-input-select>
  <app-sb-input-select
    class="d-block mt-3"
    label="Segment"
    [items]="moveSegments"
    labelKey="name"
    valueKey="id"
    [ngModel]="moveSegmentId"
    (ngModelChange)="onMoveSegmentChange($event)">
  </app-sb-input-select>
</ng-template>

<ng-template #logsTable let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Error Logs</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
            (click)="close();modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body">
    @if (isImportDataFilled()) {
    <div class="import-data-container mt-4">
      <div class="import-data-invalid">
        <span>These influencers could not be processed. Fix them and try again.</span>
      </div>
      <app-sb-table
        [rows]="importDataRows"
        [columns]="importDataColumns"
        [options]="importDataTableOptions">
        @for (fieldName of importDataTableColumns(); track $index; let i = $index) {
        <ng-template [sbTableCell]="'col_' + i" let-row>{{row.record[fieldName]}}</ng-template>
        }
      </app-sb-table>
    </div>
    }

  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close();modal.close()">Close</button>
  </div>
</ng-template>

<ng-template #preferenceHistoryTpl let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      Preference history
      @if (preferenceHistoryInfluencer) {
      <small class="d-block text-muted font-size-sm">
        {{preferenceHistoryInfluencer.email || preferenceHistoryInfluencer.name || ('#' + preferenceHistoryInfluencer.id)}}
      </small>
      }
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body">
    @if (preferenceHistoryLoading()) {
    <div class="text-center py-4">
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Loading…
    </div>
    }
    @if (!preferenceHistoryLoading() && !preferenceHistory()?.length) {
    <div class="text-muted text-center py-3">
      No preference changes recorded yet.
    </div>
    }
    @if (!preferenceHistoryLoading() && preferenceHistory()?.length) {
    <ul class="list-group list-group-flush preference-history-list">
      @for (rev of preferenceHistory(); track rev) {
      <li class="list-group-item px-0 py-2">
        <div class="d-flex justify-content-between align-items-baseline mb-1">
          <div class="preference-history-meta">
            <strong>{{rev._summary || 'Preference update'}}</strong>
            @if (rev.through || rev.created_by) {
            <span class="text-muted">
              · via {{formatPreferenceSource(rev.through)}}@if (rev.created_by) {
<span> · by {{preferenceUserName(rev.created_by)}}</span>
            }
            </span>
      }
          </div>
          <span class="text-muted preference-history-date text-nowrap ms-2">{{rev.created_at | date:'short'}}</span>
        </div>
        @if (rev._changes?.length) {
        <table class="table table-sm preference-history-table mb-0">
          <thead>
            <tr>
              <th scope="col">Field</th>
              <th scope="col">From</th>
              <th scope="col">To</th>
            </tr>
          </thead>
          <tbody>
            @for (change of rev._changes; track change) {
            <tr>
              <td>{{formatPreferenceFieldLabel(change.field)}}</td>
              <td class="text-muted">{{formatPreferenceValue(change.from, change.field)}}</td>
              <td>{{formatPreferenceValue(change.to, change.field)}}</td>
            </tr>
            }
          </tbody>
        </table>
        }
        @if (!rev._changes?.length && rev._summary) {
        <div class="preference-history-meta text-muted">
          {{rev._summary}}
        </div>
        }
      </li>
    }
    </ul>
          }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.close()">Close</button>
  </div>
</ng-template>

<ng-template #csvDownload let-modal >
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-title"
    >
      Export {{ !csvDownloadComplete() ? ': Your data is being exported' : ''}}
    </h4>
    <div class="d-flex justify-content-end">
      <button
        type="button"
        aria-label="Close button"
        class="btn-close"
        aria-describedby="modal-title"
        (click)="modal.close()"
      ></button>
    </div>
  </div>
  <div class="modal-body">
    <div class="text-center">
      @if (!csvDownloadComplete() && exportProgress().status !== 'failed') {
      <button class="btn btn-default" type="button">
        <span class="btn-wrapper--icon spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="btn-wrapper--label">
      {{exportProgress().status === 'started' ?
          'Export: started' :
          exportProgress().status === 'in-progress' ?
            'Exporting: ' + exportProgress().progress + '%' + (exportProgress().remainingTimeFormatted ? ' — remains ' + exportProgress().remainingTimeFormatted : '') :
            'Export: ' + exportProgress().status}}
    </span>
      </button>
      }
      @if (exportProgress().status === 'failed') {
      <div>
        <p class="text-danger mb-3">Export failed. Please try again.</p>
        <button class="btn btn-default" type="button" (click)="exportModelRef.close()">Close</button>
      </div>
      }
      @if (csvDownloadComplete()) {
      <a class="btn btn-default" type="button" (click)="downloadExportFile()">
        <span class="btn-wrapper--label">
          {{'File Link'}}
        </span>
      </a>
      }
    </div>
  </div>
</ng-template>
